import { Environment } from '@diritto/common/base/constants';
import { generateTransPath, Transformation } from '@diritto/common/imageKit/transformation';
import * as CryptoJS from 'crypto-js';
import { configure } from 'utils/configure';

export interface GenerateImageUrlProps {
  lazy?: boolean;
  path?: string;
  isPrivate?: boolean;
  transformation?: Transformation;
  useTransformation?: boolean;
}

const publicEndpointSelector = (publicEndpoints: string[], path: string) =>
  publicEndpoints[parseInt(CryptoJS.MD5(path).toString(), 16) % publicEndpoints.length];

export const generateImageUrl = ({
  path = '',
  isPrivate = false,
  transformation = {},
  useTransformation = configure.environment !== Environment.Local,
}: GenerateImageUrlProps) => {
  const privateEndpoint = configure.privateCdnPublicUrl || '';
  const publicEndpoints = [configure.cdnPublicUrl || ''];

  const pathWithOption = useTransformation ? generateTransPath(path, [transformation]) : path;

  // TODO : isPrivate 라면 server 에서 getSignedUrl 통해서 가져올 수 있도록 함
  return isPrivate
    ? `${privateEndpoint}/${pathWithOption}`
    : `${publicEndpointSelector(publicEndpoints, pathWithOption)}/${pathWithOption}`;
};

export const generateImageUrls = ({ transformation, ...props }: GenerateImageUrlProps) => {
  const getOptions = (format?: string) => ({
    ...props,
    transformation: {
      ...transformation,
      format,
    } as Transformation,
  });

  const jpg = generateImageUrl(getOptions('jpg'));
  const webp = generateImageUrl(getOptions('webp'));
  return { jpg, webp };
};
